module.exports = __webpack_public_path__ + "img/inform.d6de77ab.png";